import styled from 'styled-components';
import { colors, fontSizes, spacing } from 'ui/theme';
import { Link } from 'ui/links';
import { TooltipContent } from 'ui/tooltip/Tooltip.styled';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p48: pxToRem(48),
  p60: pxToRem(60),
};

type VariationThumbnailProps = {
  isThumbnailAvailable: boolean;
};

export const VariationWrapper = styled.div`
  align-items: center;
  display: flex;
  grid-column: 1 / span 1;
`;

export const VariationThumbnail = styled.div<VariationThumbnailProps>`
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.threeEights};
  display: flex;
  height: ${customSpacing.p48};
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: ${spacing.eighth};
  position: relative;
  width: ${customSpacing.p60};

  ${({ isThumbnailAvailable }) =>
    !isThumbnailAvailable
      ? {
          background: colors.grey5,
          backgroundClip: 'content-box',
        }
      : {}}
`;

export const PreviewImg = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;

export const StyledLinkOption = styled.a`
  color: inherit;

  :hover {
    color: inherit;
  }
`;

export const StyledNameLink = styled(Link)`
  span {
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const StyledTooltipContent = styled(TooltipContent)`
  word-break: break-all;
`;

export const VariationTitle = styled.div`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s14};
  line-height: ${spacing.base + spacing.plusHalf};
  padding-left: ${spacing.half};
`;

export const VariationSubtitle = styled.div`
  align-items: center;
  color: ${colors.textSecondary};
  display: flex;
  font-size: ${fontSizes.s12};
  gap: ${spacing.half};
  padding-left: ${spacing.half};
  flex-wrap: wrap;
`;

export const VariationContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;
